import {ModalContext} from 'exsportia-components'
import {useContext} from 'react'

export const useModalActions = () => {
  return useContext(ModalContext)
}
